import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SelectGroupTable = ({
  item,
  setItem,
  dataList,
  masKAccountTemplate,
  disabled = false,
  crownDisplay = false,
  approverList,
  setApproverList,
  approveFlag
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <DataTable
        dataKey="userSeq"
        className={`white-data-table hover-highlight no-shadow ${disabled ? "disabled-table" : ""}`}
        value={dataList}
        // tableStyle={{ minWidth: '30rem' }}
        emptyMessage={t("no_user_list")}
        selectionMode={disabled ? null : "checkbox"}
        selection={item}
        onSelectionChange={disabled ? undefined : (e) => setItem(e.value)}
        scrollable
        resizableColumns
      >
        <Column
          style={{ textAlign: "center", padding: "1px!important" }}
          selectionMode="multiple"
          headerStyle={{ width: "1rem" }}
        />
        {approveFlag && crownDisplay && (
          <Column
            style={{ width: "1rem" }}
            body={(rowData) => (
              <Button
                tooltip={t("approver")}
                tooltipOptions={{ position: "top" }}
                rounded
                text
                severity="secondary"
                className={`p-button-icon-only ${
                  approverList.includes(rowData?.userSeq) ? "text-yellow-500" : "opacity-50"
                }`}
                onClick={() => {
                  const userSeq = rowData?.userSeq;
                  setApproverList((prev) => {
                    if (prev.includes(userSeq)) {
                      return prev.filter((id) => id !== userSeq);
                    } else {
                      return [...prev, userSeq];
                    }
                  });
                }}
              >
                <FontAwesomeIcon icon="fa-solid fa-crown" />
              </Button>
            )}
          />
        )}
        <Column field="acct" body={masKAccountTemplate} header={t("account")} className="font-bold" />
        <Column field="name" body={masKAccountTemplate} header={t("user_name")} className="font-bold" />
      </DataTable>
    </div>
  );
};

export default SelectGroupTable;
